import { DeploymentEnv } from '@zooplus/commons-lang';

import {
  ENVS,
  SEPA_EXPRESS_LIBRARY_DEV_URL,
  SEPA_EXPRESS_LIBRARY_PROD_URL,
} from '@utilities/constants';

import styles from './sepa-express.module.scss';

export const addStyleToPlaceOrderButton = (buttonElement: HTMLButtonElement) => {
  window.requestAnimationFrame(() => {
    buttonElement.classList.remove('btn');
    buttonElement.classList.add('z-btn', 'z-btn--cart', styles.placeOrderButton);
    buttonElement.setAttribute('style', '');
  });
};

export const trackSepaExpressButtonClick = (buttonElement: HTMLButtonElement) => {
  buttonElement.addEventListener('click', () => {
    trackPaymentEvent({ type: 'click_buy' });
  });
};

export const trackPaymentEvent = (eventPayload = {}) => {
  if (window._satellite && typeof window._satellite.track === 'function') {
    window._satellite.track('payment_tracking', eventPayload);
  }
};

export const removeButtonContainer = () => {
  document.getElementById('sepa-express-container')?.remove();
};

export const getSepaExpressLibraryUrl = (env: DeploymentEnv): string => {
  return [ENVS.PROD, ENVS.BETA].includes(env)
    ? SEPA_EXPRESS_LIBRARY_PROD_URL
    : SEPA_EXPRESS_LIBRARY_DEV_URL;
};
